import { Injectable } from '@angular/core';
import { DataTransformAbstractGet } from 'app/modules/global/classes/data.transform.abstract.up';
import { FieldInterface } from 'app/modules/common/inputs/custom-fields/fields/fields.interface';
import { FeeditemInterface } from 'app/models/feed.model';

@Injectable({
  providedIn: 'root',
})
export class FeeditemDataTransformGet extends DataTransformAbstractGet {
  constructor() {
    super();
  }

  transform(el: FeeditemInterface): FeeditemInterface {
    console.log('FeeditemDataTransformGet', el);
    // if (el.feed) {
    //   const fields = el.feed.parent ? el.feed.parent.fields : el.feed.fields;
    //   this.normalizeFields(fields, el);
    // }
    return el;
  }

  protected normalizeFields(fields: FieldInterface[], element: FeeditemInterface): FieldInterface[] {
    if (!Array.isArray(fields)) {
      return fields;
    }
    fields.forEach((field: FieldInterface) => {
      //* // Formly v6
      //* field.props = field.templateOptions;
      //* delete field.templateOptions;

      if (field.type === 'input' && element.data?.[field.key]) {
        // FIX DATE BASED TYPES
        if (field.templateOptions.type === 'time') {
          element.data[field.key] = this.removeUTC(element.data[field.key].toString());
        }
        if (field.templateOptions.type === 'month') {
          element.data[field.key] = this.normalizeMonth(element.data[field.key].toString());
        }
      }
      // REMOVE INVALID IMAGE ([])
      if (field.type === 'image' && Array.isArray(element.data[field.key])) {
        delete element.data[field.key];
      }
    });

    // console.log('FEED ELEMENT GET TRANSFORM', fields);

    return fields;
  }
}
